import { Task } from '../../../../../../gql/graphql';
import { RulesTasksCards } from '../../../../Dashboard/RulesTaskCards.constanst';

const PHASES_CONFIG = [
  { key: 'approval', label: 'Approval Docs & Term Sheet', alwaysShow: true },
  { key: 'due-diligence', label: 'Property Evaluation & Due Diligence', alwaysShow: true },
  { key: 'final', label: 'Final Approval', alwaysShow: false },
  { key: 'closing', label: 'Closing', alwaysShow: false },
];

export interface PhaseGroup {
  key: string;
  label: string;
  tasks: Task[];
}

/**
 * Agrupa tasks por fase, asigna fase a las que no la tengan y ordena según RulesTasksCards.
 */
export function getTasksByPhases(tasks: Task[]): PhaseGroup[] {
  // Asignar fase a las tareas que no la tengan (mutamos copia para no tocar el input)
  const tasksWithPhase = tasks.map((task) => {
    if (!task.phase && task.key) {
      const rule = RulesTasksCards.find((item) => item.key === task.key);
      return { ...task, phase: rule?.phase?.[0] ?? task.phase };
    }
    return { ...task };
  });

  const groupedByPhase = tasksWithPhase.reduce((acc: Record<string, Task[]>, item: Task) => {
    const phaseKey = item.phase ?? 'approval';
    if (!acc[phaseKey]) acc[phaseKey] = [];
    acc[phaseKey].push(item);
    return acc;
  }, {});

  // Ordenar las tareas dentro de cada fase según su posición en RulesTasksCards
  Object.keys(groupedByPhase).forEach((phaseKey) => {
    groupedByPhase[phaseKey].sort((a: Task, b: Task) => {
      if (!a.key && !b.key) return 0;
      if (!a.key) return 1;
      if (!b.key) return -1;
      const indexA = RulesTasksCards.findIndex((rule) => rule.key === a.key);
      const indexB = RulesTasksCards.findIndex((rule) => rule.key === b.key);
      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });
  });

  return PHASES_CONFIG.filter((phase) => {
    const hasTasks = (groupedByPhase[phase.key]?.length ?? 0) > 0;
    return phase.alwaysShow || hasTasks;
  }).map((phase) => ({
    key: phase.key,
    label: phase.label,
    tasks: groupedByPhase[phase.key] || [],
  }));
}
